<template>
  <base-layout>
    <food-details-modal ref="foodDetailsModal" @edit="editFood"/>
    <food-manage-modal ref="foodManageModal" @food_stored="fetchData"/>
    <h1 slot="header">
      {{ `app.foods.` + selectedTab | trans }}
    </h1>
    <v-app id="vuetify-app">
      <v-tabs icons-and-text v-model="selectedTab" slider-color="success">
        <v-tab href="#all" v-if="hasPermission('food_list')">
          {{ `app.all`|trans }}
          <v-icon>menu</v-icon>
        </v-tab>
        <v-tab href="#own" v-if="hasPermission('food_own_list')">
          {{ `app.own` | trans }}
          <v-icon>person</v-icon>
        </v-tab>
        <v-tab href="#favourites" v-if="hasPermission('food_favorite_list')">
          {{ `app.favorites` | trans }}
          <v-icon>favorite</v-icon>
        </v-tab>
        <v-tab v-if="canUseSharing" href="#shared">
          {{ `app.shared` | trans }}
          <v-icon>share</v-icon>
        </v-tab>
        <v-tab v-else href="#shared" :disabled="true" v-tooltip="{
        content: trans('app.no_access_tooltip'),
        delay: { show: 500, hide: 2000 },
        autoHide: false,
      }">
          {{ `app.shared` | trans }}
          <v-icon>share</v-icon>
        </v-tab>
        <v-spacer></v-spacer>
        <div class="d-flex justify-content-center align-items-center">
          <v-btn color="warning" @click="resetSearch()">{{ 'app.reset' | trans }}</v-btn>
          <permission-button
              :permission="canCreate"
              color="primary"
              :tooltip="{top: true, bottom: false, attach: false}"
              class="ml-0 mr-0"
              @click="addFood"
          >
            {{ 'app.foods.add_food' | trans }}
          </permission-button>
        </div>
        <v-tab-item
            :key="`all`"
            :value="`all`"
        >
          <foods-table
              :group="`all`"
              ref="allFoods"
              @show="showFood"
              @edit="editFood"
          ></foods-table>
        </v-tab-item>
        <v-tab-item
            :key="`own`"
            :value="`own`">
          <foods-table
              :group="`own`"
              ref="ownFoods"
              @show="showFood"
              @edit="editFood"
          ></foods-table>
        </v-tab-item>
        <v-tab-item
            :key="`favourites`"
            :value="`favourites`">
          <foods-table
              :group="`favourites`"
              ref="favouritesFoods"
              @show="showFood"
              @edit="editFood"
          ></foods-table>
        </v-tab-item>
        <v-tab-item
            :key="`shared`"
            :value="`shared`"
        >
          <foods-table
              :group="`shared`"
              ref="sharedFoods"
              @show="showFood"
              @edit="editFood"
          ></foods-table>
        </v-tab-item>
      </v-tabs>
    </v-app>
  </base-layout>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import {DIETITIAN_FREE, DIETITIAN_TEST} from "../../utils/roles";

export default {
  props: {
    group: String,
  },
  data: () => ({
    groups: [
      'all',
      'own',
      'favourites',
      'shared',
    ],
    selectedTab: null,
  }),
  created() {
    this.selectedTab = this.group;
  },
  async mounted() {
    await this.fetchOwnFoodsCount();
    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    if (!!params.get('add')) {
      this.addFood();
    }
  },
  computed: {
    ...mapGetters(['hasPermission', 'canUseSharing', 'userRole', 'ownFoodsCount']),
  },
  watch: {
    selectedTab: {
      handler() {
        this.fetchData();
      }
    }
  },
  methods: {
    ...mapActions(['fetchOwnFoodsCount']),
    fetchData() {
      this.$refs[this.selectedTab + 'Foods'].fetchData();
    },
    resetSearch() {
      this.$refs[this.selectedTab + 'Foods'].resetSearch();
    },
    canCreate() {
      if (this.hasPermission('food_system_create')) {
        return true;
      }

      if (!this.hasPermission('food_own_create')) {
        return false;
      }
      return !((this.userRole === DIETITIAN_FREE || this.userRole === DIETITIAN_TEST) && this.ownFoodsCount >= 20);
    },
    showFood(e) {
      this.$refs.foodDetailsModal.open(e.id);
    },
    addFood() {
      this.$refs.foodManageModal.open();
    },
    editFood(e) {
      this.$refs.foodManageModal.open(e.id);
    },
  }
}
</script>
